import {forwardRef} from 'react';
import {AppButton, AppButtonProps} from '../AppButton/AppButton';
import './appOutlinedButton.less';

export type AppOutlinedButtonProps = AppButtonProps

export const AppOutlinedButton = forwardRef<HTMLButtonElement, AppOutlinedButtonProps>(({
    children,
    className = '',
    ...rest
}, ref) => (
    <AppButton
        ref={ref}
        className={`app-outlined-button ${className}`}
        {...rest}
    >
        {children}
    </AppButton>
));
